import { Optional } from '@pogokid/util'
import { FetchResponse, ResponseJsonType } from './fetch'

export interface ResponseWithRefetch<T = void> {
  refetch(): T
}

export interface SingleResponse<Schema> {
  data: Schema | null
  error?: Error | null
}

export interface AsyncSingleResponse<Schema> {
  value?: Optional<Schema>
  loading: boolean
  error?: Error | null
}

export interface QueryResponse<Schema> {
  data: Schema[]
  error?: Error | null
}

export interface AsyncQueryResponse<Schema> {
  value?: Optional<Schema[]>
  loading: boolean
  error?: Error | null
}

/**
 * Throw an error coming from any of the Response types
 */
export async function throwOnResponseError<
  Schema,
  R extends SingleResponse<Schema> | QueryResponse<Schema>
>(req: Promise<R>): Promise<R> {
  const res = await req
  if (res.error) {
    throw res.error
  }
  return res
}

/**
 * Throw an error coming from any of the Response types
 */
export async function throwOnFetchError<
  ResponseJson extends ResponseJsonType,
  R extends FetchResponse<ResponseJson>
>(req: Promise<R>): Promise<R> {
  const res = await req
  if (res.error) {
    throw res.error
  }
  return res
}
